import { render, staticRenderFns } from "./V2LessonNav.vue?vue&type=template&id=38f5e395&scoped=true&"
import script from "./V2LessonNav.vue?vue&type=script&lang=js&"
export * from "./V2LessonNav.vue?vue&type=script&lang=js&"
import style0 from "./V2LessonNav.vue?vue&type=style&index=0&id=38f5e395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5e395",
  null
  
)

export default component.exports